import styled from 'styled-components';

export const StyledEnvStateAndTag = styled.div`
  display: flex;
  align-items: center;
  margin: 2.4rem 0;
`;

export const StylesEnvStateText = styled.p`
  margin-right: 1.6rem;
`;

export const StyledRoomsList = styled.ul`
  overflow-y: auto;
  max-height: 20vh;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  list-style: disc;
  margin: 0.8rem 0 2.4rem 0;
  color: ${({ theme }) => theme.colors.text.main};

  > li {
    list-style-position: inside;
  }

  > li:not(:first-of-type) {
    margin-top: 0.8rem;
  }
`;

export const StyledCredentialsList = styled.ul`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin: 2.4rem 0;
  color: ${({ theme }) => theme.colors.text.main};

  > li {
    list-style-position: inside;
    margin-top: 1.6rem;

    > span {
      margin-left: 1.6rem;
      display: inline-block;
    }

    > a {
      margin-left: 1.6rem;
      color: ${({ theme }) => theme.colors.info.main};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
